
import React, { Component } from 'react';

import { ClipLoader } from 'react-spinners';

/**
 *  Default Spinner Component
 */
export default class Spinner extends Component {

  render() {
    return (
      <ClipLoader
        color={'#122B4F'}
        loading={this.props.loading}
      />
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js